import * as React from 'react';
import { SVGProps } from 'react';
import { withForgeIconProps } from './ForgeIconProps';
interface SVGRProps {
  title?: string;
  titleId?: string;
}

const SvgNotAllowedSmall = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps): JSX.Element => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="fi_c_icon"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M3.04999 3.05005L12.95 12.95M15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8Z"
      stroke={props.color}
      strokeWidth={2}
      strokeMiterlimit={10}
      strokeLinecap="round"
    />
  </svg>
);

SvgNotAllowedSmall.displayName = 'SvgNotAllowedSmall';
const NotAllowedSmall = withForgeIconProps(SvgNotAllowedSmall, {
  name: 'NotAllowed',
  usage:
    'Use to indicate an item or service that is not available or not allowed.',
  related: 'prohibit, no, none',
  isLabelRequired: false,
  isNeutralInteractive: false,
  size: 'small',
});
export default NotAllowedSmall;
